// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__3T0RZ","small":"Logo_small__2zpWJ"};